import { refreshToken } from "../../auth/authUtils";
import { getUtilitiesApiUrl } from "../../utils";

const AgentListAPI = async (isRetry = false) => {
    const token = sessionStorage.getItem('access_token');
    if (!token) {
        throw new Error('Bearer token not found');
    }

    const baseUrl = getUtilitiesApiUrl();
    if (!baseUrl) {
        throw new Error('EVA agent list URL is not configured');
    }

    try {
        const response = await fetch(`${baseUrl}/api/v1/agents?active_only=true&limit=100&offset=0`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // Handle 401 Unauthorized errors by refreshing the token and retrying
        if (response.status === 401 && !isRetry) {
            console.warn('Token expired, refreshing...');
            try {
                const newToken = await refreshToken();
                if (newToken) return await AgentListAPI(true);
            } catch (refreshError) {
                console.error('Failed to refresh token:', refreshError);
                throw refreshError;
            }
        }

        if (!response.ok) {
            throw new Error(`Failed to fetch agents list: ${response.status} ${response.statusText}`);
        }

        return response.json();

    } catch (error) {
        console.error('Error in AgentListAPI:', error);
        throw error;
    }
};

export default AgentListAPI;